import * as io from 'io-ts';
import { boolean } from '@shared/core/types/common';

const rootDefinition: io.MixedObject<OLO.Config.HiddenLocations> = {
    enabled: boolean,
};

export const hiddenLocationsSchema = io.type(rootDefinition);
